import Vue from "vue";

import Vuex from 'vuex'
Vue.use(Vuex)


import userType from './modules/userType.js';

const store = new Vuex.Store({
    modules: {
        userType,
    },
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js